import { DonNghiPhep } from "../donnghiphep/DonNghiPhep";

export class ThongBaoChungPagingResponse {
    "data": Array<ThongBaoChungResponse>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class ThongBaoChungResponse {
    "id": number;
    "noiDung": string;
    "trangThai": number;
    "loaiThongBao": number;
    "idChiTiet": number;
    "tenLoaiThongBao": string;
    "params": string;
}

export class DuyetNghiPhepVaThemGioResponse {
    "nghiPheps": Array<DonNghiPhep>
}